// extracted by mini-css-extract-plugin
export default {"company":"Company_company__30Wfi"};